import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../styles/terms-policies.css";
import { useSelector } from "react-redux";
import { SITE_NAME } from "../variables";

function TermsAndPoliciesPage() {
  const { settings } = useSelector((state) => state.site);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = `${SITE_NAME} - Terms and Policies`;
  }, []);

  return (
    <div className="tp-container">
      {/* <button onClick={() => navigate("/")} className="tp-back-button">
        <FaArrowLeft /> Back to Home
      </button> */}

      <h1 className="tp-main-title">Terms and Conditions</h1>

      <div className="tp-section">
        <p dangerouslySetInnerHTML={{ __html: settings.terms }}></p>
      </div>
    </div>
  );
}

export default TermsAndPoliciesPage;
